import { CanDeactivate } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CanDeactivateGuard implements CanDeactivate<any> {
  canDeactivate(component: any): Promise<boolean> | boolean {
    if (component) {
      if (component.hasChanged && (!component.leavepage)) {
        component.warningOpened = true;
      } else {
        component.warningOpened = false;
      }
    }
    return new Promise((resolve) => {
      setTimeout(async () => {
        try {  
          let element : any;
          if (component.hasChanged && (!component.leavepage)) {
            element = await this.waitForElementToAppear('btnYes'); 
          }
          else {
            element = this.waitForElementToAppear('btnYes'); 
          }
 
          if (typeof (element) !== 'undefined' && element != null) {
            document.getElementById('btnYes').onclick = () => { resolve(true); };
            document.getElementById('btnNo').onclick = () => { resolve(false); };
          }  else  { resolve(true) } ;
        } catch (error) {
          // Handle the error if the element doesn't appear within the specified timeout 
          resolve(true); // Resolve as true in case of an error
        }
        }, 300);
      });
  }

  async waitForElementToAppear(elementId: string, timeout = 5000) {
    return new Promise((resolve, reject) => {
      const startTime = Date.now();
  
      function checkElement() {
        const element = document.getElementById(elementId);
  
        if (element) {
          // Element found, resolve the promise
          resolve(element);
        } else if (Date.now() - startTime < timeout) {
          // Continue checking if the timeout hasn't been reached
          setTimeout(checkElement, 100); // Check every 100 milliseconds
        } else {
          // Timeout reached, reject the promise
          resolve(null);
        }
      }
   
      // Start the initial check
      checkElement();
    });
  }
}
